module.exports = __webpack_public_path__ + "static/img/whatisnew-flow-1-4-2.804f923.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/whatisnew/whatisnew-flow-1-4-2.png
// module id = b4dX
// module chunks = 4